<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭">
    <efs-stl-settle-apply-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></efs-stl-settle-apply-form>
  </j-modal>
</template>

<script>

  import EfsStlSettleApplyForm from './EfsStlSettleApplyForm'
  export default {
    name: 'EfsStlSettleApplyModal',
    components: {
      EfsStlSettleApplyForm
    },
    data () {
      return {
        title:'',
        width:1224,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      setCompanyCode(){},
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>